import * as __mod_react from "react";
import * as __mod_react_dom from "react-dom";
import * as __mod_jsx from "react/jsx-runtime";
import * as __mod_rrd from "react-router-dom";
var require = (m) => {
  var __mods = {
    "react": __mod_react,
    "react-dom": __mod_react_dom,
    "react/jsx-runtime": __mod_jsx,
    "react-router-dom": __mod_rrd,
  };
  if (__mods[m]) return __mods[m];
  throw new Error("Cannot require " + m);
};
import{jsx as i}from"react/jsx-runtime";var e={default:"https://cdn.prod.website-files.com/646226ec552e56d4f1caaa20/656970f534417e587ec38843_256by256.png"};function c({variant:r="default",className:a,width:t,height:o,alt:n="Snakker logo"}){let s=e[r]??e.default;return i("img",{src:s,alt:n,className:a,width:t,height:o,style:{objectFit:"contain",width:t,height:o},"data-id":"element-50"})}export{c as Logo};
//# sourceMappingURL=library.js.map
